define([
    "./nlgPermissionModule",
    "./nlgPermissionDirective",
    "./permissionService"
], function () {
});
